import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {setShowEmojiModal, setShowSavedReplies} from "../../../actions/ui";
import EmojiContainer from "../EmojiContainer";
import SavedRepliesModal from "../SavedRepliesModal";

const AdditionalModals = ({curVar, msgRef, isValidForm, showSavedReplies, setShowSavedReplies}) => {
    const dispatch = useDispatch()

    function insertTextAtLastCursor(text) {
        const tagify = msgRef[curVar].current;
        if (!tagify || !tagify._savedRange) return;

        const input = tagify.DOM.input;
        input.focus(); // Safari sometimes needs this

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(tagify._savedRange);

        document.execCommand("insertText", false, text);

        // Оновлюємо збережену позицію після вставки
        const newRange = selection.getRangeAt(0).cloneRange();
        tagify._savedRange = newRange;
    }

    useEffect(() => {
        const tagify = msgRef[curVar].current;
        if (!tagify) return;

        const input = tagify.DOM.input;

        const saveRange = () => {
            const sel = window.getSelection();
            if (!sel.rangeCount) return;

            const range = sel.getRangeAt(0);
            if (input.contains(range.startContainer)) {
                tagify._savedRange = range.cloneRange();
            }
        };

        input.addEventListener('click', saveRange);
        input.addEventListener('keyup', saveRange);
        input.addEventListener('mouseup', saveRange);

        return () => {
            input.removeEventListener('click', saveRange);
            input.removeEventListener('keyup', saveRange);
            input.removeEventListener('mouseup', saveRange);
        };
    }, []);

    const setMessage = (message) => {
        insertTextAtLastCursor(message)
        isValidForm()
    }

    const cursor_position = (e) => {
        const sel = document.getSelection();
        sel.modify("extend", "backward", "paragraphboundary");
        const pos = sel.toString().length;
        if(sel.anchorNode != undefined) sel.collapseToEnd();
        return pos;
    }

    const handleEmojiSelect = (emoji) => {
        setMessage(emoji.native)
        cursor_position()
    }

    const clickOutsideEmoji = (e) => {
        if (!e.target.classList.contains("saved-reply-item") && !e.target.classList.contains("emoji-icon") &&
            e.target.localName !== "path" && e.target.localName !== "em-emoji-picker") {
            dispatch(setShowEmojiModal(false))
        }
    }

    useEffect(()=>{
        msgRef[curVar]?.current?.DOM?.input?.focus()
    },[])

    return (
      <>
        <EmojiContainer isValidForm={isValidForm} handleEmojiSelect={handleEmojiSelect} clickOutside={clickOutsideEmoji} className="col-lg-9 mx-auto emoji-modal-fixed"/>
        {showSavedReplies && <>
            <SavedRepliesModal fade={false} setShowSavedReplies={setShowSavedReplies} setMessage={setMessage}/>
            <div className = "modal-backdrop fade show noclose"/>
        </>}
    </>
    )
}

export default React.memo(AdditionalModals)